import { render } from "./long-insure-report-add.vue?vue&type=template&id=90dc6dbc&scoped=true&ts=true"
import script from "./long-insure-report-add.vue?vue&type=script&lang=ts"
export * from "./long-insure-report-add.vue?vue&type=script&lang=ts"

import "./long-insure-report-add.vue?vue&type=style&index=0&id=90dc6dbc&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90dc6dbc"]])

export default __exports__